var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPtsCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 18.8588 22.2872",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.5045 0H7.02618C6.27938 0 5.67188 0.714251 5.67188 1.59216V5.32905H6.90815V1.59216C6.90815 1.51566 6.96111 1.4534 7.02618 1.4534H17.5045C17.5696 1.4534 17.6226 1.51566 17.6226 1.59216V13.9108C17.6226 13.9874 17.5696 14.0496 17.5045 14.0496H14.425V15.503H17.5045C18.2513 15.503 18.8588 14.7888 18.8588 13.9108V1.59216C18.8588 0.714251 18.2513 0 17.5045 0Z",
    fill: "url(#paint0_linear_0_356)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.8327 6.78409H1.35434C0.607548 6.78409 0 7.49834 0 8.3763V20.695C4.12092e-05 21.5729 0.607548 22.2872 1.35434 22.2872H11.8327C12.5795 22.2872 13.187 21.5729 13.187 20.695V8.3763C13.1871 7.49834 12.5794 6.78409 11.8327 6.78409ZM11.8327 20.8338H1.35434C1.28923 20.8338 1.23628 20.7715 1.23628 20.695V8.3763C1.23628 8.29975 1.28923 8.23749 1.35434 8.23749H11.8327C11.8978 8.23749 11.9508 8.29975 11.9508 8.3763V20.695H11.9508C11.9508 20.7715 11.8978 20.8338 11.8327 20.8338Z",
    fill: "url(#paint1_linear_0_356)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_356",
    x1: 3.45573,
    y1: 32.1688,
    x2: -10.5761,
    y2: 22.1031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D38F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E827D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_356",
    x1: -2.21616,
    y1: 38.953,
    x2: -16.2481,
    y2: 28.8872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D38F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E827D9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPtsCopy);
export default __webpack_public_path__ + "static/media/pts_copy.77f29366d1e7200aecb6a9261be322a1.svg";
export { ForwardRef as ReactComponent };